/**
 * Telefoonnummer-controle — één regel voor de hele stack.
 *
 * Waarom verplicht bij bestellen: de bezorging gaat met eigen transport, en die meldt de
 * bezorgdag met een sms. Zonder nummer hoort de klant dus niets over het bezorgmoment.
 *
 * De check blijft bewust ruim: spaties, punten, streepjes, haakjes en een landcode (+31 / 0031)
 * mogen. Wat overblijft moet 9 t/m 15 cijfers zijn — genoeg om lege of nep-invoer ("-", "nvt")
 * te weren zonder buitenlandse nummers af te wijzen.
 */

/** Alleen de cijfers; een "00"-landcode-prefix valt weg (0031… → 31…). */
export function phoneDigits(raw: string): string {
  const s = raw.trim().replace(/[^0-9+]/g, "");
  const zonderPrefix = s.startsWith("+") ? s.slice(1) : s.startsWith("00") ? s.slice(2) : s;
  return zonderPrefix.replace(/\D/g, "");
}

/** True als het nummer bruikbaar lijkt (9–15 cijfers na normalisatie). */
export function isValidPhone(raw: string): boolean {
  const d = phoneDigits(raw);
  return d.length >= 9 && d.length <= 15;
}
